(function () {
    const CART_KEY = 'marketplace_cart';
    const CART_UPDATED = 'cartUpdated';

    function getCart() {
        try {
            const raw = localStorage.getItem(CART_KEY);
            return raw ? JSON.parse(raw) : [];
        } catch (e) {
            return [];
        }
    }

    function saveCart(cart) {
        localStorage.setItem(CART_KEY, JSON.stringify(cart));
        window.dispatchEvent(new CustomEvent(CART_UPDATED));
    }

    function getItemCount() {
        const cart = getCart();
        return cart.reduce(function (sum, item) {
            return sum + (parseInt(item.quantity, 10) || 0);
        }, 0);
    }

    function getSubtotal() {
        const cart = getCart();
        return cart.reduce(function (sum, item) {
            const price = parseFloat(item.price) || 0;
            const qty = parseInt(item.quantity, 10) || 0;
            return sum + (price * qty);
        }, 0);
    }

    function formatCurrency(amount) {
        const n = parseFloat(amount) || 0;
        return 'USD ' + n.toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    function itemKey(item) {
        const vid = item.variant_id != null ? String(item.variant_id) : 'base';
        return (item.product_uid || '') + '|' + vid;
    }

    function addItem(newItem) {
        const cart = getCart();
        const key = itemKey(newItem);
        const existingIndex = cart.findIndex(function (i) {
            return itemKey(i) === key;
        });

        if (existingIndex >= 0) {
            const existing = cart[existingIndex];
            const addQty = parseInt(newItem.quantity, 10) || 1;
            existing.quantity = (parseInt(existing.quantity, 10) || 0) + addQty;
            if (newItem.max_quantity != null && newItem.max_quantity > 0) {
                existing.max_quantity = newItem.max_quantity;
            }
            if (newItem.product_id != null) {
                existing.product_id = parseInt(newItem.product_id, 10);
            }
            if (newItem.vendor_organisation_unit_id != null) {
                existing.vendor_organisation_unit_id = parseInt(newItem.vendor_organisation_unit_id, 10);
            }
            if (existing.max_quantity != null && existing.quantity > existing.max_quantity) {
                existing.quantity = existing.max_quantity;
            }
        } else {
            const maxQty = newItem.max_quantity != null && newItem.max_quantity > 0 ? newItem.max_quantity : null;
            cart.push({
                product_uid: newItem.product_uid,
                product_id: newItem.product_id != null ? parseInt(newItem.product_id, 10) : null,
                vendor_organisation_unit_id: newItem.vendor_organisation_unit_id != null
                    ? parseInt(newItem.vendor_organisation_unit_id, 10)
                    : null,
                product_name: newItem.product_name,
                variant_id: newItem.variant_id,
                variant_name: newItem.variant_name,
                quantity: parseInt(newItem.quantity, 10) || 1,
                price: parseFloat(newItem.price) || 0,
                image: newItem.image,
                max_quantity: maxQty
            });
        }

        saveCart(cart);
    }

    function removeItem(index) {
        const cart = getCart();
        if (index >= 0 && index < cart.length) {
            cart.splice(index, 1);
            saveCart(cart);
        }
    }

    function updateQuantity(index, quantity) {
        const cart = getCart();
        if (index >= 0 && index < cart.length) {
            const qty = Math.max(1, parseInt(quantity, 10) || 1);
            cart[index].quantity = qty;
            saveCart(cart);
        }
    }

    function updateHeaderCart() {
        const count = getItemCount();
        const total = getSubtotal();
        const countEl = document.getElementById('cartItemCount');
        const totalEl = document.getElementById('cartTotal');
        const badgeEl = document.getElementById('cartBadge');

        if (countEl) {
            countEl.textContent = count === 1 ? '1 item' : count + ' items';
        }
        if (totalEl) {
            totalEl.textContent = formatCurrency(total);
        }
        if (badgeEl) {
            if (count > 0) {
                badgeEl.textContent = count > 99 ? '99+' : String(count);
                badgeEl.style.display = '';
            } else {
                badgeEl.style.display = 'none';
            }
        }

        var badgeMobile = document.getElementById('cartBadgeMobile');
        if (badgeMobile) {
            if (count > 0) {
                badgeMobile.textContent = count > 99 ? '99+' : String(count);
                badgeMobile.style.display = '';
            } else {
                badgeMobile.style.display = 'none';
            }
        }
    }

    window.MarketplaceCart = {
        getCart: getCart,
        getItemCount: getItemCount,
        getSubtotal: getSubtotal,
        addItem: addItem,
        removeItem: removeItem,
        updateQuantity: updateQuantity,
        formatCurrency: formatCurrency,
        updateHeaderCart: updateHeaderCart,
        CART_UPDATED: CART_UPDATED
    };

    if (typeof jQuery !== 'undefined') {
        jQuery(document).ready(function () {
            updateHeaderCart();
            window.addEventListener(CART_UPDATED, updateHeaderCart);
        });
    }
})();